import { Icons } from '@agro-club/agroclub-shared'
import { FC, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { RailwayRoute, RatesTabTypes } from '../../types'
import { EditRailsRatesModal } from './EditRailsRatesModal'
import styled from 'styled-components'
import { RemoveRailsRates } from './RemoveRailsRates'

interface Props {
  onSuccess: () => void
  routeData: RailwayRoute
  currentProductType?: RatesTabTypes
}

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
export const RailsRatesActionCell: FC<Props> = ({ onSuccess, routeData }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false)

  return (
    <>
      <ActionsContainer>
        <AButton id="edit" color="secondary" Icon={Icons.IconEdit} size="small" onClick={() => setIsModalOpen(true)} />
        <AButton
          id="deleteRailRoute"
          color="destruct"
          Icon={Icons.IconDelete}
          size="small"
          onClick={() => setShowRemoveModal(true)}
        />
      </ActionsContainer>
      {}
      {isModalOpen && (
        <EditRailsRatesModal onClose={() => setIsModalOpen(false)} refetch={onSuccess} routeData={routeData} />
      )}
      {showRemoveModal && (
        <RemoveRailsRates onClose={() => setShowRemoveModal(false)} id={routeData.id} onSuccess={onSuccess} />
      )}
    </>
  )
}
